import React from 'react';

const buttonStyle = {
  display: 'inline-block',
  width: '100px',
  height: '38px',
  cursor: 'pointer',
};

const handleReadmoreURL = (readMoreURL) => {
  if (
    readMoreURL.split(':')[0] === 'https' ||
    readMoreURL.split(':')[0] === 'http'
  ) {
    return readMoreURL;
  }
  return '//' + readMoreURL;
};

function ButtonReadMore(props) {
  const color = props.color || 'white';
  return (
    <a
      style={buttonStyle}
      href={handleReadmoreURL(props.href)}
      target="_blank"
      rel="noopener noreferrer"
    >
      <svg viewBox="0 0 190 72" xmlns="http://www.w3.org/2000/svg">
        <path
          d="m152.4,1.5c-39.2,-0.4 -78.5,-0.4 -117.7,0c-21.9,0.2 -37.1,19.3 -33.7,40.7c2.7,16.5 17.2,28.6 34.8,28.7c19.1,0.1 38.2,0 57.4,0c19.4,0 38.8,0.1 58.2,0c19.6,-0.2 35.1,-15.5 35.2,-34.5c0.2,-18.8 -14.8,-34.8 -34.2,-34.9z"
          opacity="0.3"
        />
        <g>
          <path
            fill={color}
            d="m82.8,32.5c-1.2,0 -2.1,0.4 -2.6,1.3c-0.5,0.8 -0.8,2.2 -0.8,3.9l0,1.6c0,1.8 0.3,3.2 0.8,4s1.4,1.3 2.6,1.3c1.3,0 2.3,-0.7 3,-2l0,-8.2c-0.7,-1.3 -1.7,-1.9 -3,-1.9z"
          />
          <path
            fill={color}
            d="m66.1,39.6c-0.7,0.5 -1.1,1.3 -1.1,2.3c0,0.9 0.2,1.6 0.5,2c0.4,0.4 1,0.6 1.9,0.6c0.7,0 1.3,-0.2 1.9,-0.5c0.6,-0.4 1,-0.8 1.3,-1.3l0,-3.9l-1.5,0c-1.3,0 -2.3,0.3 -3,0.8z"
          />
          <path
            fill={color}
            d="m153.4,1.5c-39.2,-0.4 -78.5,-0.4 -117.7,0c-21.9,0.2 -37.1,19.3 -33.7,40.7c2.7,16.5 17.2,28.6 34.8,28.7c19.1,0.1 38.2,0 57.4,0c19.4,0 38.8,0.1 58.2,0c19.6,-0.2 35.1,-15.5 35.2,-34.5c0.2,-18.8 -14.8,-34.8 -34.2,-34.9zm-107.6,45.1l-3,0l-3.9,-8.8l-3.8,0l0,8.8l-2.8,0l0,-21.8l6.1,0c2.1,0 3.8,0.6 4.8,1.7s1.7,2.7 1.7,4.9c0,1.3 -0.3,2.5 -0.9,3.5c-0.6,1 -1.4,1.8 -2.5,2.3l4.2,9.3l0.1,0.1l0,0zm13.6,-7.3l-9,0l0,0.4c0,1.7 0.3,3 1,3.8c0.7,0.8 1.6,1.2 2.8,1.2c0.8,0 1.5,-0.2 2.1,-0.4c0.6,-0.3 1.2,-0.8 1.7,-1.4l1.4,1.7c-1.2,1.6 -2.9,2.4 -5.2,2.4c-2,0 -3.6,-0.6 -4.6,-1.8s-1.6,-3 -1.7,-5.3l0,-2c0,-2.4 0.5,-4.3 1.6,-5.7s2.5,-2.1 4.4,-2.1c1.9,0 3.3,0.6 4.2,1.8s1.4,3.1 1.4,5.6l-0.1,1.8l0,0zm14.3,7.3l-2.7,0c-0.2,-0.3 -0.3,-0.9 -0.3,-1.8c-0.9,1.4 -2.1,2.1 -3.6,2.1c-1.5,0 -2.6,-0.4 -3.4,-1.2c-0.8,-0.8 -1.2,-2 -1.2,-3.5c0,-1.7 0.6,-3 1.7,-3.9s2.7,-1.5 4.6,-1.5l2,0l0,-1.7c0,-1 -0.2,-1.7 -0.6,-2.1s-1.1,-0.6 -2,-0.6c-0.8,0 -1.5,0.2 -2,0.7c-0.5,0.5 -0.8,1.1 -0.8,1.8l-2.7,0c0,-0.8 0.2,-1.6 0.7,-2.4s1.2,-1.3 2,-1.8c0.8,-0.4 1.8,-0.6 2.8,-0.6c1.7,0 2.9,0.4 3.8,1.2s1.3,2 1.3,3.6l0,8.2c0,1.2 0.2,2.3 0.5,3.2l-0.1,0.3l0,0zm14.7,0l-2.4,0l-0.1,-1.7c-0.9,1.4 -2.1,2 -3.7,2c-1.7,0 -3,-0.7 -3.9,-2s-1.4,-3.1 -1.5,-5.5l0,-1.7c0,-2.5 0.5,-4.4 1.4,-5.7s2.3,-2 4,-2c1.5,0 2.8,0.6 3.6,1.9l0,-8.4l2.7,0l-0.1,23.1l0,0zm30.2,0l-2.6,0l0,-10.6c0,-1.2 -0.2,-2 -0.6,-2.6c-0.4,-0.6 -1.1,-0.9 -2.1,-0.9c-0.8,0 -1.5,0.3 -2,0.9s-0.8,1.4 -0.9,2.4l0,10.8l-2.7,0l0,-10.8c0,-2.2 -0.9,-3.4 -2.7,-3.4c-1.3,0 -2.3,0.7 -2.8,2l0,12.1l-2.6,0l0,-16.2l2.5,0l0.1,1.5c1,-1.2 2.3,-1.8 3.9,-1.8c1.8,0 3.1,0.8 3.8,2.3c1,-1.6 2.4,-2.3 4.2,-2.3c3,0 4.5,1.9 4.6,5.6l-0.1,11l0,0zm16,-7.3c0,2.3 -0.6,4.2 -1.7,5.6s-2.7,2 -4.5,2c-1.9,0 -3.4,-0.7 -4.5,-2s-1.7,-3.1 -1.8,-5.4l0,-1.8c0,-2.4 0.6,-4.2 1.7,-5.6c1.1,-1.4 2.7,-2.1 4.5,-2.1s3.4,0.7 4.5,2s1.7,3.2 1.8,5.5l0,1.8l0,0zm8.9,-6.5c-1.4,0 -2.3,0.7 -2.8,2.2l0,11.6l-2.7,0l0,-16.2l2.6,0l0,1.7c0.7,-1.3 1.7,-2 3,-2c0.4,0 0.8,0.1 1,0.2l0,2.6c-0.3,-0.1 -0.7,-0.1 -1.1,-0.1zm14.7,6.5l-9,0l0,0.4c0,1.7 0.3,3 1,3.8c0.7,0.8 1.6,1.2 2.8,1.2c0.8,0 1.5,-0.2 2.1,-0.4c0.6,-0.3 1.2,-0.8 1.7,-1.4l1.4,1.7c-1.2,1.6 -2.9,2.4 -5.2,2.4c-2,0 -3.6,-0.6 -4.6,-1.8s-1.6,-3 -1.7,-5.3l0,-2c0,-2.4 0.5,-4.3 1.6,-5.7s2.5,-2.1 4.4,-2.1c1.9,0 3.3,0.6 4.2,1.8s1.4,3.1 1.4,5.6l-0.1,1.8l0,0z"
          />
          <path
            fill={color}
            d="m53.7,32.4c-1.1,0 -1.9,0.4 -2.4,1.1s-0.8,1.9 -0.9,3.5l6.4,0l0,-0.4c-0.1,-1.5 -0.3,-2.6 -0.8,-3.3c-0.5,-0.6 -1.3,-0.9 -2.3,-0.9z"
          />
          <path
            fill={color}
            d="m38.4,27.2l-3.3,0l0,8.3l3.3,0c1.2,0 2.1,-0.4 2.8,-1.1s1,-1.7 1,-3c0,-2.8 -1.3,-4.2 -3.8,-4.2z"
          />
          <path
            fill={color}
            d="m128.3,32.4c-1.1,0 -2,0.5 -2.6,1.4c-0.7,1 -1,2.3 -1,3.9l0,1.5c0,1.7 0.3,3 1,3.9c0.7,1 1.5,1.4 2.6,1.4c2.3,0 3.5,-1.7 3.6,-5.1l0,-1.8c0,-1.7 -0.3,-3 -1,-3.9c-0.6,-0.8 -1.5,-1.3 -2.6,-1.3z"
          />
          <path
            fill={color}
            d="m152.5,32.4c-1.1,0 -1.9,0.4 -2.4,1.1s-0.8,1.9 -0.9,3.5l6.4,0l0,-0.4c-0.1,-1.5 -0.3,-2.6 -0.8,-3.3c-0.6,-0.6 -1.3,-0.9 -2.3,-0.9z"
          />
        </g>
      </svg>
    </a>
  );
}

export default ButtonReadMore;
